import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { isString } from 'lodash';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { pathnameSelector } from '../../../modules/selectors/url';
import { DEPLOYMENT_ENV } from '../../../config';
import { originSelector } from '../../../modules/selectors/vHostRequestLocation';
import { additionalCrumbsSelector } from '../../../modules/selectors/additionalCrumbs';
import { categoryUrlSelector, standortUrlSelector } from '../../../modules/selectors/url';
import { categoriesSelector } from '../../../modules/selectors/standort/categories';
import { getBaseCrumbs } from '../BreadCrumb/breadCrumbHelper';
import { googleSearchDelearInfo } from '../GoogleSearch/googleSearchDelearInfo';

function HeadMeta({ seoMetaDataResponse, markenStandortResponse }) {
    const pathname = useSelector(pathnameSelector);
    const origin = useSelector(originSelector);
    const standortUrl = useSelector(standortUrlSelector);
    const categories = useSelector(categoriesSelector);
    const categoryUrl = useSelector(categoryUrlSelector);
    const location = useLocation();
    let additionalCrumbs = useSelector(additionalCrumbsSelector);
    if (!additionalCrumbs) {
        additionalCrumbs = [];
    }
    const crumbs = useMemo(() => {
        const crumbs = getBaseCrumbs({ standortUrl, categories, categoryUrl });
        return [...crumbs, ...additionalCrumbs];
    }, [standortUrl, categories, categoryUrl, additionalCrumbs]);

    const googleSearchDelearInfoData = useMemo(() => 
        googleSearchDelearInfo({ markenStandort: markenStandortResponse.data }), 
    [markenStandortResponse.data]);

    const seoMetaData = seoMetaDataResponse.data ?? {};

    const titlePrefix = isString(seoMetaData.title) ? `${seoMetaData.title}` : '';
    let titlePostfix = markenStandortResponse.data?.seoMetaDataTitlePostfix ? ` | ${markenStandortResponse.data?.seoMetaDataTitlePostfix}` : '| Autoteile plus Service';
    if (titlePostfix === " |  " || titlePrefix.includes(" | ")) {
        titlePostfix = "";
    }
    const standort = markenStandortResponse.data ?? {};

    let robotsContent;
    if (DEPLOYMENT_ENV !== 'production') {
        // Hide public test environments from bots.
        robotsContent = 'noindex, nofollow';
    } else {
        if(seoMetaDataResponse.status === 'SUCCESS') {
            robotsContent = seoMetaData.robots || 'noindex, follow';
        }
    }

    let canonicalHref;
    if (seoMetaData.canonical === 'filters') {
        canonicalHref = "";
    } else if (seoMetaData.canonical) {
        canonicalHref = `${origin}${pathname}`;
    } else if (pathname.includes('search')) {
        canonicalHref = '';
    }  else {
        let sanitizedPath = pathname;
        try {
            if (/^https?:\/\//i.test(sanitizedPath)) {
                sanitizedPath = new URL(sanitizedPath).pathname;
            }
        } catch (e) {}
        sanitizedPath = (sanitizedPath || '')
            .replace(/https?:\/\/[^/]+/gi, '')
            .replace(/\/{2,}/g, '/')
            .replace(/^([^/])/, '/$1');
        canonicalHref = `${origin}${sanitizedPath}`;
    }
    const Baseorigin = origin.split('//');

    const isProduction = DEPLOYMENT_ENV === "production"
    const title = standort.url !== "de" ? `${titlePrefix}${titlePostfix}` : "AutoteilePlusService | Shopübersicht";

    return (
        <Helmet>
            <title>
                {title}
            </title>
            {standort?.paymentProvider === '' && 
                <script src="https://secure.pay1.de/client-api/js/v1/payone_hosted_min.js" async></script>
            }
            {googleSearchDelearInfoData && (
                <script type="application/ld+json">
                    {JSON.stringify(googleSearchDelearInfoData)}
                </script>
            )}


            {/* google tag for NOA */}
            {standort?.googleAnalyticsId == null ? '' : 
            <script type="text/plain" class="optanon-category-C0002">
                {`
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','${standort.googleAnalyticsId}');
                `}
            </script> 
            }

            {/* {standort.title !== "Nord Ostsee | Area Hamburg" ? '' : <script async src="https://www.googletagmanager.com/gtag/js?id=AW-969384639" type="text/plain" class="optanon-category-C0002"></script>}
            {standort.title !== "Nord Ostsee | Area Hamburg" ? '' :
                <script type="text/plain" class="optanon-category-C0002">
                    {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date()); 
                    gtag('config','AW-969384639' );
                    `}
                </script>
            }
            {standort.title !== "Nord Ostsee | Area Hamburg" ? '' :
                <script type="text/plain" class="optanon-category-C0002">
                    {`
                    function gtag_report_conversion(url) {
                        var callback = function () {
                        if (typeof(url) != 'undefined') {
                        window.location = url;
                        }
                        };
                        gtag('event', 'conversion', {
                        'send_to': 'AW-969384639/TtGECIar2osDEL_Fns4D',
                        'value': 0.01,
                        'currency': 'EUR',
                        'transaction_id': '',
                        'event_callback': callback
                        });
                        return false;
                        }
                    `}
                </script>
            } */}

            {/* dello facebook tracking */}
            {standort.url !== "ernst-dello-grossraum-hamburg" || !isProduction ? '' :
                <script type="text/plain" class="optanon-category-C0002">
                    {`
                    !function(f,b,e,v,n,t,s)
                    {if(f.fbq)return;n=f.fbq=function(){n.callMethod ?
                    n.callMethod.apply(n, arguments) : n.queue.push(arguments)};
                    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                    n.queue=[];t=b.createElement(e);t.async=!0;
                    t.src=v;s=b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t,s)}(window, document,'script',
                    'https://connect.facebook.net/en_US/fbevents.js');
                    fbq('init', '1156565265134470');
                    fbq('track', 'PageView');
                    `}
                </script>
            }
            {standort.url !== "ernst-dello-grossraum-hamburg" || !isProduction ? '' : <noscript type="text/plain" class="optanon-category-C0002">{`<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1156565265134470&ev=PageView&noscript=1"/>`}</noscript>}

            {/* dello google tag */}
            {isProduction && standort.googleTagId && (
                <script
                    async
                    src={`https://www.googletagmanager.com/gtag/js?id=${standort.googleTagId}`}
                    type="text/plain"
                    class="optanon-category-C0002"
                />
            )}

            {isProduction && standort.googleTagId && (
                <script type="text/plain" class="optanon-category-C0002">
                    {`
                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());
                        gtag('config', '${standort.googleTagId}');
                    `}
                </script>
            )}
            {standort.url !== "ernst-dello-grossraum-hamburg" || !isProduction ? '' :
                <meta name="google-site-verification" content="D9KBCx3CR9KPmDtLucupl0PBKFMygxBIKGlpyzSkutM" />
            }
            <meta name="robots" content={robotsContent} />
            <meta name="google" content="nositelinkssearchbox" />
            {seoMetaData.description && <meta name="description" content={seoMetaData.description} />}
            {standort.title !== "Witteler Mercedes/smart" ? '' : <link rel="icon" type="image/png" href="/favicon-witteler.png" />}
            {standort.url !== "ernst-dello-grossraum-hamburg" ? '' : <link rel="icon" type="image/png" href="/Favicon-DELLO-GRUPPE-Shop.png" />}
            {standort.url !== "auto-scholz-region-bamberg" ? '' : <link rel="icon" type="image/png" href="/MB-star_S_p_4C.jpg" />}
            {standort.url !== "autonova-oberfranken" ? '' : <link rel="icon" type="image/png" href="/Mossbauer-Favicon.png" />}
            {standort.url !== "autoschmitt-frankfurt-idstein" ? '' : <link rel="icon" type="image/png" href="/Favicon AS_sw.png" />}
            {standort.url !== "autoschmitt-frankfurt-idstein" ? '' : <meta name="google-site-verification" content="vO6HLazEQu9jys9wRUoAU6xtCSBKG69kuxcGF1knmaw" />}
            {standort.url !== "gottfried-schultz" ? '' :  <meta name="p:domain_verify" content="5796eca7805d7fb373eb53f67452f1fb" />}
            <link rel="canonical" href={canonicalHref} />
            {standort.url !== "nord-ostsee-automobile-hamburg" ? '' : <link rel="icon" type="image/png" href="/NOA-favicon-16x16.png" />}
            {standort.url !== "ernst-koenig-region-schwarzwald" ? '' : <link rel="icon" type="image/png" href="/ernst-konig-favicon.png" />}
            {standort.url !== "autohaus-gramling-nordbaden" ? '' : <link rel="icon" type="image/png" href="/gramling-favicon.png" />}
            {standort.url !== "auto-anders-region-bremen" ? '' : <link rel="icon" type="image/png" href="/anders-favicon.png" />}
            {standort.url !== "haeusler-automobile-grossraum-muenchen" ? '' : <link rel="icon" type="image/png" href="/haeusler-favicon.png" />}
            {standort.url !== "hoppmann-region-siegen" ? '' : <link rel="icon" type="image/png" href="/hoppmann-favicon.png" />}
            {standort.url !== "loehrgruppe-region-koblenz" ? '' : <link rel="icon" type="image/png" href="/lohr-favicon.ico" />}
            {standort.url !== "autohaus-tobaben-region-hamburg" ? '' : <link rel="icon" type="image/png" href="/tobaben-favicon.ico" />}
            {standort.url !== "auto-glinicke-region-kassel" ? '' : <link rel="icon" type="image/png" href="https://www.glinicke.de/favicon.ico" />}
            {standort.url !== "gottfried-schultz" ? '' : <link rel="icon" type="image/png" href="/gfs-favicon.png" />}
            {standort.url !== "autohaus-boettche" ? '' : <link rel="icon" type="image/png" href="/autohaus-boettche-favicon.png" />}
            {standort.url !== "shop-auto-jakob" ? '' : <link rel="icon" type="image/png" href="/fahr-jakob-favicon.png" />}
            {standort.url !== "estore-rkg" ? '' : <link rel="icon" type="image/png" href="/rkg-favicon.png" />}
            {standort.url !== "hanser-leiber" ? '' : <link rel="icon" type="image/png" href="/Favicon H+L.jpg" />}
            {standort.url !== "autohaus-ramsperger" ? '' : <link rel="icon" type="image/png" href="/ramsperger-favicon.png" />}
            {standort.url !== "autohaus-zimpel-franke" ? '' : <link rel="icon" type="image/png" href="/zimpel-franke-favicon.png" />}
            {standort.url !== "walter-coenen-grossraum-moenchengladbach" ? '' : <link rel="icon" type="image/png" href="/walter-coenen-favicon.png" />}
            {standort.url !== "schmidt-hoffmann-schleswig-holstein" ? '' : <link rel="icon" type="image/png" href="/schmidt-hoffmann-favicon.png" />}
            {standort.url !== "auto-glinicke-region-kassel" || !isProduction ? '' : <script async src="https://www.googletagmanager.com/gtag/js?id=GTM-N3JLP8J" type="text/plain" class="optanon-category-C0002"></script>}
            {standort.url !== "auto-glinicke-region-kassel" || !isProduction ? '' : <script type="text/plain" class="optanon-category-C0002">
                {`
                                                                                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                                                                                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                                                                                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                                                                                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                                                                                    })(window,document,'script','dataLayer','GTM-N3JLP8J');
                                                                                `}
            </script>}

            {location.pathname !== "/" ? '' :
                <script type="application/ld+json">
                    {`{
                  "@context": "https://schema.org",
                  "@type": "WebSite",
                  "url": "${origin}",
                  "potentialAction": {
                    "@type": "SearchAction",
                    "target": {
                      "@type": "EntryPoint",
                      "urlTemplate": "https://query.${Baseorigin[1]}/search?q={search_term_string}"
                    },
                    "query-input": "required name=search_term_string"
                  }
                }`}
                </script>
            }
            <meta name="google-site-verification" content="mnT5UzSNIFT4w9uQpGdEFf42cmryd_wKb4Ztl4qr6-8" />
            {standort.url !== "gottfried-schultz" || !isProduction ? '' : <script type="text/plain" class="optanon-category-C0002">
                {`!function(f,b,e,v,n,t,s){
                    if(f.fbq)return;n=f.fbq=function()
                    {n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                    n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
                    (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
                    fbq('init', '546108804037493'); 
                    fbq('track', 'PageView');                                                              
                    `}
            </script>
            }
            {standort.url !== "gottfried-schultz" || !isProduction ? '' : <script async src="https://connect.facebook.net/en_US/fbevents.js"></script>
            }
            {standort.url !== "gottfried-schultz" || !isProduction ? '' : <noscript>{`<img height="1" width="1" src="https://www.facebook.com/tr?id=546108804037493&ev=PageView&noscript=1"/>`}</noscript>}
            {standort.url !== "gottfried-schultz" || !isProduction ? '' : <meta name="facebook-domain-verification" content="qkl5p2g0n2rdsh2rn1f22k2ykhkkdt" />}
            {/* {standort.url !== "gottfried-schultz" ? '' : <noscript type="text/plain" class="optanon-category-C0002">{`<img height="1" width="1"src="https://www.facebook.com/tr?id=546108804037493&ev=PageView&noscript=1"/>`}</noscript>} */}

            {

                <script type="application/ld+json">
                    {`{
                    "@context": "https://schema.org",
                    "@type": "BreadcrumbList",
                    "itemListElement":[
                        ${crumbs.map((crumb, index) => {
                        let url = crumb.url;
                        const label = crumb.label;
                        const name = crumb.name;
                        if (url === undefined) {
                            const normalized = (label || '')
                            .replace(/ä/g, 'ae')
                            .replace(/ö/g, 'oe')
                            .replace(/ü/g, 'ue')
                            .replace(/Ä/g, 'Ae')
                            .replace(/Ö/g, 'Oe')
                            .replace(/Ü/g, 'Ue')
                            .replace(/ß/g, 'ss')
                            url = `/${normalized}`;
                        }
                        try {
                            if (/^https?:\/\//i.test(url)) {
                                url = new URL(url).pathname;
                            }
                        } catch (e) {}
                        url = (url || '')
                            .replace(/https?:\/\/[^/]+/gi, '')
                            .replace(/\/{2,}/g, '/')
                            .replace(/^([^/])/, '/$1');
                        return (
                            `{
                                    "@type": "ListItem",
                                    "position": ${index},
                                    "name": "${name ?? label}",
                                    "item": "${origin}${url}"
                                }`
                        )
                    })
                        }
                    ]
                }`}
                </script>
            }

            {/*autohaus-marzahn-grossraum-berlin*/}
            {standort.url !== "autohaus-marzahn-grossraum-berlin"  ? '' : <link rel="icon" type="image/png" href="/Marzahn-favicon-16x16.ico" />}
            {/* Audi Zentrum Kassel GmbH & Co. KG */}
            {standort.url !== "gottfried-schultz" || !isProduction ? '' : <script type="text/plain" class="optanon-category-C0004" src="https://eu1-config.doofinder.com/2.x/48938716-66e5-42ac-9617-e2c3aa22c046.js" async></script>}
            {/* start Pinterest Tag  */}
            {standort.url !== "gottfried-schultz" || !isProduction ? '' :
                <script type="text/plain" class="optanon-category-C0002">
                    {`
                        !function(e){if(!window.pintrk){window.pintrk = function () {
                        window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
                        n=window.pintrk;n.queue=[],n.version="3.0";var
                        t=document.createElement("script");t.async=!0,t.src=e;var
                        r=document.getElementsByTagName("script")[0];
                        r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
                        pintrk('load', '2614303895018', {em: ''});
                        pintrk('page')
                    `}
                </script>
            }            
            {standort.url !== "gottfried-schultz" || !isProduction ? '' :
                <noscript>
                    {`<img height="1" width="1" style={{ display: 'none' }} alt="" src="https://ct.pinterest.com/v3/?event=init&tid=2614303895018&pd[em]=<hashed_email_address>&noscript=1" />`}
                </noscript>
            }            
            {/* end Pinterest Tag  */}

            {/* Matomo Tag Manager */}
            {standort.matomoTagManagerContainer == null ? '' :
                <script>
                    {`
                var _mtm = window._mtm = window._mtm || [];
                _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
                (function() {
                    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                    g.async=true; g.src='${standort.url !== "ernst-dello-grossraum-hamburg" ?
                            'https://cdn.matomo.cloud/autoteileplusservice.matomo.cloud/container_' :
                            'https://dello-gruppe.de/matomo/js/container_'}${standort.matomoTagManagerContainer}.js'; s.parentNode.insertBefore(g,s);
                })();
                `}
                </script>
            }

            {/* Clarity */}
            {standort.clarityId == null ? '' :
                <script type="text/plain" class="optanon-category-C0002">
                    {`
                        (function(c,l,a,r,i,t,y){
                            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                        })(window, document, "clarity", "script", "${standort.clarityId}");
                `}
                </script>
            }

            {/* Hotjar */}
            {standort.hotjarId == null  ? '' :
                <script type="text/plain" class="optanon-category-C0002">
                    {`
                (function(h,o,t,j,a,r){
                    h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
                h._hjSettings={hjid:${standort.hotjarId},hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
                `}
                </script>
            }

            {/*  TikTok Pixel GFS */}
            {standort.url !== "gottfried-schultz" || !isProduction ? '' :
                <script type="text/plain" class="optanon-category-C0002">
                    {` !function (w, d, t) { w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for( var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script") ;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)}; ttq.load('CSOV0PJC77U450RMU360'); ttq.page(); }(window, document, 'ttq'); 
                `}
                </script>}
            {standort.url !== "de" ?               
                <script async src="https://cdn.eye-able.com/configs/www.autoteileplusservice.de.js"></script>
                : ''
            } 
            {standort.url !== "de" ?               
                <script async src="https://cdn.eye-able.com/public/js/eyeAble.js"></script>
                : ''
            } 
        </Helmet>
    );
}

export default HeadMeta;
